import { render } from "./SideBarDesktopCliente.vue?vue&type=template&id=2c555e49"
import script from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"
export * from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__